import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import SliderCarousel from "../../components/GramSliderCarousel";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
import Advertise from "../../components/Advertise";
import { getImageUrl } from "../../redux/types";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    width: "90vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.between("sm", "xs")]: {
      marginTop: theme.spacing(0),
      width: "100vw",
      flexDirection: "column",
      // backgroundColor: "red",
    },
  },
  sliderImg: {
    // height: "30vh",
    // width: "100%",
    // objectFit: "contain",

    width: "90vw",

    objectFit: "contain",
    [theme.breakpoints.between("sm", "xs")]: {
      marginTop: theme.spacing(0),
      width: "100%",
      height: "auto",
    },
  },
  adImg: {
    height: 300,
    width: 270,
    objectFit: "contain",
    [theme.breakpoints.between("sm", "xs")]: {
      marginTop: theme.spacing(0),
      width: "100%",
      height: 150,
      // backgroundColor: "red",
    },
  },
  SliderCarouselContainer: {
    flex: 1,
  },
  adContainer: {
    height: "100%",
    width: "100%",
    paddingLeft: theme.spacing(1),
  },
  container: {
    width: "100%",
    display: "flex",

    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.between("sm", "xs")]: {
      flexDirection: "column",
    },
  },
}));

const Sliders = ({ data }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <div className={classes.root}>
          {data?.data[0]?.image && (
            <div className={classes.SliderCarouselContainer}>
              <img
                src={getImageUrl(data?.data[0]?.image)}
                className={classes.sliderImg}
              />
            </div>
          )}
          {/* <MobileHidden>
            <div className={classes.adContainer}>
              <div style={classes.adImageContainer}>
                <img
                  src={data?.advertise?.imageSrc}
                  className={classes.adImg}
                  onClick={() => window.open(data?.advertise?.link)}
                />
              </div>
            </div>
          </MobileHidden> */}
        </div>
      </div>
      {/* <DesktopHidden>
        <Advertise data={data?.advertise} />
      </DesktopHidden> */}
    </>
  );
};
export default Sliders;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import { Grid, Typography } from "@material-ui/core";
// import Advertise from "../../components/Advertise";
// import SliderCarousel from "../../components/GramSliderCarousel";
// import MobileHidden from "../../components/Common/Hidden/MobileHidden";
// import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
// const useStyles = makeStyles((theme) => ({
//   root: {
//     marginTop: theme.spacing(3),
//     width: "100vw",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     [theme.breakpoints.between("sm", "xs")]: {
//       marginTop: theme.spacing(0),
//       // backgroundColor: "red",
//     },
//   },
//   gridContainer: {
//     width: "90vw",
//     [theme.breakpoints.between("sm", "xs")]: {
//       width: "100vw",
//     },
//   },
//   marginBottom: {
//     marginBottom: theme.spacing(2),
//     fontSize: "1.5rem",
//     [theme.breakpoints.between("sm", "xs")]: {
//       fontSize: "1.1rem",
//       fontWeight: "500",
//     },
//   },
//   title: {
//     fontSize: "1.5rem",
//     [theme.breakpoints.between("sm", "xs")]: {
//       fontSize: "1rem",
//     },
//   },
// }));

// const Sliders = ({ data }) => {
//   const classes = useStyles();

//   return (
//     <div className={classes.root}>
//       <Grid
//         container
//         className={classes.gridContainer}
//         alignItems="flex-end"
//         justify="space-between"
//       >
//         <Grid item lg={10} md={10} sm={12} xs={12}>
//           <SliderCarousel data={data?.data} />
//         </Grid>
//         <Grid
//           item
//           lg={2}
//           container
//           alignItems="center"
//           justify="center"
//           md={2}
//           sm={12}
//           xs={12}
//         >
//           <DesktopHidden>
//             <Typography className={classes.marginBottom}>સૌજન્ય</Typography>
//           </DesktopHidden>
//           <Advertise data={data.advertise} />
//         </Grid>
//       </Grid>
//     </div>
//   );
// };
// export default Sliders;
